import React from 'react';

import styles from './ProposalBlockWrapper.module.scss';

export type Props = {
  children: React.ReactNode;
  title?: string;
  link?: {
    label: string;
    click?: () => void;
  };
};

export const ProposalBlockWrapper = (props: Props) => {
  return (
    <div className={styles.proposal_details_card}>
      <div className={styles.proposal_details_row}>
        <div className={styles.proposal_details_header}>{props.title}</div>
        {props.link && (
          <a
            className={styles.proposal_details_link}
            data-testid="proposal-block-link"
            onClick={props.link.click}
          >
            {props.link.label}
          </a>
        )}
      </div>
      {props.children}
    </div>
  );
};
